import { enrichmentStatsHttp } from '../../_shared/infrastructure/enrichment-stats.http';
import type { MetricsGateway } from './metrics.gateway';

/** Real implementation: the shared stats read is all Metrics needs. */
export const httpMetricsGateway: MetricsGateway = { ...enrichmentStatsHttp };
